import { useEffect } from 'react';
import { CheckListSquareIcon, CheckSolidIcon, NotApplicableIcon, TimesSolidIcon } from '../../../../../assets/icons';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectExaminerReportData, selectSelectedInterviewApplicant } from '../../../../../store/workspace/selectors';
import { setRecruitingInterviewReportModal } from '../../../../../store/workspace/slice';
import styles from './style.module.scss';

export default function RecruitingInterviewReport() {
    const dispatch = useDispatch();
    const reportData = useSelector(selectSelectedInterviewApplicant);

    // useEffect(() => {
    //     return () => {
    //         dispatch(setExaminerReportData(null));
    //     }
    // }, []);

    const renderResult = () => {
        switch (reportData?.result) {
            case 'True':
                return <CheckSolidIcon />;
            case 'False':
                return <TimesSolidIcon />;
            case 'Not Applicable':
                return <NotApplicableIcon />;
            default:
                return ''
        }
    };

    return (
        <Modal
            size='xxl'
            icon={<CheckListSquareIcon />}
            childClassName={styles.wrapper}
            title={`Criteria explanation`}
            closeFunc={() => dispatch(setRecruitingInterviewReportModal(false))}
        >
            <div className={styles.status}>
                <span>{reportData?.result}</span>
                {renderResult()}
            </div>
            <p className={styles.report}>
                {reportData?.reason}
            </p>
            <div className={styles.actions}>
                <Button
                    text='Close'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setRecruitingInterviewReportModal(false))}
                />
            </div>
        </Modal>
    )
}
